import { Link } from "react-router-dom";
import { KineticLine, FadeUp } from "./motion";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-stone-300">
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10">
      <div className="max-w-4xl">
        <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tighter text-cream sm:text-5xl lg:text-6xl">
          <KineticLine>Ready to listen.</KineticLine>
          <KineticLine delay={0.12}>Ready to serve.</KineticLine>
          <KineticLine delay={0.24}>
            <span className="text-terracotta">Ready to work.</span>
          </KineticLine>
        </h2>
      </div>

      <FadeUp delay={0.2}>
        <div className="mt-16 grid gap-12 border-t border-white/10 pt-12 md:grid-cols-3">
          <div>
            <p className="font-display text-lg font-bold text-cream">Winnie Ho</p>
            <p className="mt-2 text-sm leading-relaxed text-stone-400">
              A community voice for stronger education. School Board Trustee candidate for
              Vaughan, York Region.
            </p>
          </div>
          <nav data-testid="footer-nav" className="flex flex-col gap-3 text-sm">
            <Link data-testid="footer-link-about" to="/about" className="transition-colors hover:text-cream">About Winnie</Link>
            <Link data-testid="footer-link-platform" to="/platform" className="transition-colors hover:text-cream">Platform</Link>
            <Link data-testid="footer-link-get-involved" to="/get-involved" className="transition-colors hover:text-cream">Get Involved</Link>
            <Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-cream">Contact</Link>
          </nav>
          <div className="text-sm text-stone-400">
            <p className="font-medium text-stone-300">For students. For families. For Vaughan.</p>
            <p className="mt-3 leading-relaxed">
              Every child deserves to feel valued, respected, included, supported, and empowered
              to succeed.
            </p>
          </div>
        </div>
      </FadeUp>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-stone-500 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">
          &copy; {new Date().getFullYear()} Winnie Ho Campaign. All rights reserved.
        </p>
        <p data-testid="footer-disclaimer">
          Authorized by the campaign to elect Winnie Ho, School Board Trustee.
        </p>
      </div>
    </div>
  </footer>
);
